(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-sticker"] && !Shopify.designMode) return;
  try {
    
/* Full-circle circular text with tangent orientation + width-aware proportional spacing */
(function () {
  var SECTIONS = document.querySelectorAll('[data-sticker-section]');
  if (!SECTIONS.length) return;

  SECTIONS.forEach(function (ROOT) {
    var WRAP   = ROOT.querySelector('.dfs-sticker');
    var RING   = ROOT.querySelector('.dfs-sticker .sticker');
    var IMG    = ROOT.querySelector('.dfs-sticker .submark img');
    var BTN    = ROOT.querySelector('.dfs-sticker-trigger');
    var MODAL  = ROOT.querySelector('.dfs-modal');
    var PANEL  = MODAL ? MODAL.querySelector('.dfs-modal__panel') : null;
    var CLOSES = MODAL ? MODAL.querySelectorAll('[data-close]') : [];

    if (!WRAP || !RING || !IMG) return;

    // cache raw text
    if (!RING.hasAttribute('data-raw')) {
      RING.setAttribute('data-raw', (RING.textContent || '').trim());
    }

    // canvas measurer using element's computed font
    function makeMeasurer(el) {
      var c = document.createElement('canvas');
      var ctx = c.getContext('2d');
      var cs = getComputedStyle(el);
      var font = [
        cs.fontStyle || 'normal',
        cs.fontVariant || 'normal',
        cs.fontWeight || '400',
        cs.fontSize || '16px',
        cs.lineHeight && cs.lineHeight !== 'normal' ? '/' + cs.lineHeight : '',
        cs.fontFamily || 'sans-serif'
      ].join(' ').replace(/\s+/g,' ').trim();
      ctx.font = font;
      return function (ch) { return ctx.measureText(ch).width; };
    }

    function cssNumber(varName, fallback) {
      var v = getComputedStyle(WRAP).getPropertyValue(varName).trim();
      var n = parseFloat(v);
      return isNaN(n) ? fallback : n;
    }

    function build() {
      var text = RING.getAttribute('data-raw') || '';
      if (!text.length) return;

      var imgW = IMG.getBoundingClientRect().width;
      if (!imgW) { requestAnimationFrame(build); return; }

      var gapPx     = cssNumber('--ring-gap', 12);
      var tracking  = cssNumber('--ring-tracking', 0);   // px added between glyphs
      var startDeg  = cssNumber('--ring-start-deg', -90);
      var direction = cssNumber('--ring-direction', 1) >= 0 ? 1 : -1;

      var fontPx    = parseFloat(getComputedStyle(RING).fontSize) || 16;
      var baselinePad = cssNumber('--ring-offset', 2);  // baseline clearance from the image

      var R = (imgW / 2) + gapPx + baselinePad;
      var D = Math.ceil(R * 2);

      WRAP.style.setProperty('--ring-diameter', D + 'px');
      RING.style.width  = D + 'px';
      RING.style.height = D + 'px';

      // width-proportional distribution to fill 360°
      var measure = makeMeasurer(RING);
      var chars   = Array.from(text);
      var widths  = chars.map(function (ch) { return ch === ' ' ? measure('·') * 0.45 : measure(ch); });
      var totalW  = widths.reduce(function (s,w){ return s + w + tracking; }, 0);
      if (!totalW) return;

      RING.innerHTML = '';
      var startRad = startDeg * Math.PI / 180;
      var accum = 0; // accumulated width

      for (var i = 0; i < chars.length; i++) {
        var w    = widths[i] + tracking;
        var frac = w / totalW;                 // share of full circumference
        var sweepRad = frac * Math.PI * 2;     // angle slice for this glyph
        var midRad   = startRad + direction * (accum + sweepRad / 2);
        var angleDeg = midRad * 180 / Math.PI;

        var span = document.createElement('span');
        span.textContent = chars[i];
        // Tangent orientation:
        span.style.transform =
          'rotate(' + angleDeg + 'deg) translate(' + R + 'px) rotate(' + (90 * direction) + 'deg)';

        RING.appendChild(span);
        accum += sweepRad;
      }
    }

    // Build on ready / on image load
    if (IMG.complete) build();
    else IMG.addEventListener('load', build, { once: true });

    // Rebuild on resize & when image resizes
    var t;
    window.addEventListener('resize', function(){ clearTimeout(t); t = setTimeout(build, 120); });
    if ('ResizeObserver' in window) new ResizeObserver(build).observe(IMG);

    // Optional external trigger
    document.addEventListener('df:rebuild-sticker', function (e) {
      if (e && e.detail && e.detail.root && e.detail.root !== ROOT) return;
      build();
    });

    // Modal wiring (unchanged)
    var lastFocused = null;
    function openModal(){ if(!MODAL) return; lastFocused=document.activeElement; MODAL.classList.add('is-open'); MODAL.setAttribute('aria-hidden','false'); if(PANEL) PANEL.focus(); document.addEventListener('keydown', onKey); if(BTN) BTN.setAttribute('aria-expanded','true'); }
    function closeModal(){ if(!MODAL) return; MODAL.classList.remove('is-open'); MODAL.setAttribute('aria-hidden','true'); document.removeEventListener('keydown', onKey); if(BTN){ BTN.setAttribute('aria-expanded','false'); BTN.focus(); } else if(lastFocused){ lastFocused.focus(); } }
    function onKey(e){ if(e.key==='Escape') closeModal(); }
    if (BTN && MODAL && BTN.tagName==='BUTTON') BTN.addEventListener('click', function(e){ e.preventDefault(); openModal(); });
    (CLOSES||[]).forEach(function(el){ el.addEventListener('click', closeModal); });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
